import React from "react";
import styled from "styled-components";
import NavLinks from "./NavLinks";
import BlogLogoLink from "./BlogLogoLink";

const SideNav = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  z-index: 99;
  top: 0;
  right: 0;
  ${props => props.theme.media.tabletUp`
    position: sticky;
    flex-direction: column;
    top: 60px;
    max-width: 240px;
  `};
`;

const NavWrapper = styled.div`
  display: block;
  max-width: 160px;
  margin: 60px;
`;

const BlogNav = () => (
  <SideNav>
    <NavWrapper>
      <BlogLogoLink />
      <NavLinks />
    </NavWrapper>
  </SideNav>
);

export default BlogNav;
